import { apiClient, getActivePvzId, isSupabaseConfigured } from './_shared.js'

export async function createPvz(orgId, pvzData) {
  return await apiClient('/pvz', {
    method: 'POST',
    body: JSON.stringify({
      org_id: orgId,
      ...pvzData
    })
  })
}

export async function getPvzBusinessHours() {
  const pvzId = getActivePvzId()
  if (!pvzId) return null
  return await apiClient(`/pvz/${pvzId}/business-hours`)
}

export async function getPlannedShiftToday(employeeId) {
  const pvzId = getActivePvzId()
  if (!pvzId) return null
  return await apiClient(`/schedule/planned/today?pvzId=${pvzId}&employeeId=${employeeId}`)
}

export async function getMisplacedItems() {
  const pvzId = getActivePvzId()
  if (!pvzId) return []
  return await apiClient(`/violations/misplaced-items?pvzId=${pvzId}`)
}

export async function createMisplacedItemReport(data) {
  const pvzId = getActivePvzId()
  return await apiClient('/violations/misplaced-items', {
    method: 'POST',
    body: JSON.stringify({ ...data, pvz_id: pvzId })
  })
}

export async function resolveMisplacedItemReport(item, resolution, resolvedBy) {
  return await apiClient(`/violations/misplaced-items/${item.id}/resolve`, {
    method: 'PUT',
    body: JSON.stringify({ resolution, resolved_by: resolvedBy })
  })
}

export async function getWorkloadForecast(pvzId, forceRefresh = false) {
  if (!isSupabaseConfigured) {
    // Демо-данные для прогнозирования нагрузки
    return {
      forecast: [
        {
          date: new Date(Date.now()).toISOString().split('T')[0],
          dayOfWeek: 'Понедельник',
          workload: 'High',
          expectedAcceptance: 520,
          expectedIssued: 410,
          scheduledStaff: ['Иванов Иван (сотрудник)'],
          recommendation: 'Высокая нагрузка! На смене только 1 человек. Рекомендуется вызвать помощника.'
        },
        {
          date: new Date(Date.now() + 86400000).toISOString().split('T')[0],
          dayOfWeek: 'Вторник',
          workload: 'Medium',
          expectedAcceptance: 320,
          expectedIssued: 280,
          scheduledStaff: ['Петров Петр (сотрудник)'],
          recommendation: 'Смена укомплектована оптимально.'
        },
        {
          date: new Date(Date.now() + 86400000 * 2).toISOString().split('T')[0],
          dayOfWeek: 'Среда',
          workload: 'Low',
          expectedAcceptance: 120,
          expectedIssued: 110,
          scheduledStaff: ['Иванов Иван (сотрудник)', 'Петров Петр (помощник)'],
          recommendation: 'Низкая нагрузка. На смене 2 человека. Рекомендуется сократить смену до 1 сотрудника.'
        },
        {
          date: new Date(Date.now() + 86400000 * 3).toISOString().split('T')[0],
          dayOfWeek: 'Четверг',
          workload: 'Medium',
          expectedAcceptance: 350,
          expectedIssued: 310,
          scheduledStaff: ['Сидоров Сидор (сотрудник)'],
          recommendation: 'Смена укомплектована оптимально.'
        },
        {
          date: new Date(Date.now() + 86400000 * 4).toISOString().split('T')[0],
          dayOfWeek: 'Пятница',
          workload: 'High',
          expectedAcceptance: 580,
          expectedIssued: 490,
          scheduledStaff: ['Сидоров Сидор (сотрудник)', 'Иванов Иван (помощник)'],
          recommendation: 'Смена укомплектована оптимально.'
        },
        {
          date: new Date(Date.now() + 86400000 * 5).toISOString().split('T')[0],
          dayOfWeek: 'Суббота',
          workload: 'Medium',
          expectedAcceptance: 290,
          expectedIssued: 270,
          scheduledStaff: ['Петров Петр (сотрудник)'],
          recommendation: 'Смена укомплектована оптимально.'
        },
        {
          date: new Date(Date.now() + 86400000 * 6).toISOString().split('T')[0],
          dayOfWeek: 'Воскресенье',
          workload: 'Low',
          expectedAcceptance: 90,
          expectedIssued: 85,
          scheduledStaff: ['Иванов Иван (сотрудник)'],
          recommendation: 'Смена укомплектована оптимально.'
        }
      ],
      summary: 'В целом график на следующую неделю выглядит сбалансированным, однако в среду есть избыток персонала при низкой нагрузке, а в понедельник — дефицит помощника при пиковой приёмке.'
    }
  }
  const id = pvzId || getActivePvzId()
  if (!id) return null
  return await apiClient(`/analytics/workload-forecast?pvzId=${id}&forceRefresh=${forceRefresh}`)
}
